var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeatexchanger = function SvgHeatexchanger(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path941",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M11.547 8.219c.77 0 1.415-.632 1.415-1.415s-.646-1.414-1.415-1.414a1.413 1.413 0 1 0 0 2.829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path943",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M20.368 8.219c.783 0 1.415-.632 1.415-1.415s-.632-1.414-1.415-1.414-1.415.632-1.415 1.414.632 1.415 1.415 1.415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path945",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "m10.283 11.954 5.757 3.955 5.73-3.955"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path947",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.638,
    d: "M10.187 1.325H21.88a4.133 4.133 0 0 1 4.122 4.12v21.122a4.133 4.133 0 0 1-4.122 4.12H10.187a4.133 4.133 0 0 1-4.122-4.12V5.445a4.133 4.133 0 0 1 4.122-4.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path949",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M11.547 26.992c.77 0 1.415-.632 1.415-1.414s-.646-1.415-1.415-1.415c-.783 0-1.415.632-1.415 1.415s.632 1.414 1.415 1.414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path951",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M20.368 26.992a1.413 1.413 0 1 0 0-2.829c-.783 0-1.415.632-1.415 1.415s.632 1.414 1.415 1.414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path953",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "m10.283 17.296 5.757 3.955 5.73-3.955"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeatexchanger);
export default ForwardRef;